import type { GetDocumentResponse } from 'product-document-page-shared';
import React from 'react';

import type { Config } from '../../../server/config';
import type { ReaderViewState, SendMessage } from '../../types';
import type {
    GoogleAnalyticsTracker,
    MonitorTracker,
    StoryTracker,
    WebsiteTracker,
} from '../../util/tracking';
import type { GridArea, GridLayout } from './useGridLayout';

export type DocumentData = GetDocumentResponse & {
    hosts: Config['hosts'];
    // For SSR to work properly, referrer cannot be drawn from window (which
    // does not exist in SSR context).
    // Referrer is instead gotten from the request object in the handler, and
    // passed on via prop/context.
    referrer: string;
    // advertisement targeting need to know the running enviroment.
    enviroment: 'prod' | 'dev';
    crawler: false | { pageNumber?: number; pageTexts: string[] };
    trackers: {
        monitor: MonitorTracker;
        website: WebsiteTracker;
        story: StoryTracker;
        googleAnalytics: GoogleAnalyticsTracker;
    };
    appState: {
        sendMessageToReader: React.MutableRefObject<SendMessage | undefined>;
        readerRef: React.MutableRefObject<HTMLDivElement | null>;
        currentLayout: { name: GridLayout; areas: Set<GridArea> };
        currentPageNumbers: [number[], (v: number[]) => void];
        readerViewState: [ReaderViewState, (v: ReaderViewState) => void];
    };
};

const DocumentContext = React.createContext<DocumentData>({} as DocumentData);

export default DocumentContext;
